import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraNeuropsychologicalEvaluationsSecondaryRecIllustration: FunctionComponent<Props> = ({
  size = 64,
}) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M24.4858 13.8031C24.4858 13.8031 37.4878 10.7383 38.725 10.8839C39.8669 11.0182 40.6794 11.3352 41.6168 14.0731C42.5202 16.7109 48.6973 43.2993 48.7087 43.3621C49.3649 47.0054 47.7087 47.3567 46.1378 47.9865C44.5854 48.6107 27.2555 52.6995 22.6422 53.7778C21.4335 54.0606 20.1111 54.0977 19.0913 53.7464C18.2845 53.4679 17.4209 53.2379 16.4977 50.2588C15.3231 46.4712 10.0407 21.2254 10.0407 21.2254C10.0407 21.2254 9.474 18.1177 12.569 17.1765C15.6625 16.2353 24.4844 13.8031 24.4844 13.8031H24.4858Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M25.1104 16.2938C25.1104 16.2938 36.3796 13.6374 37.4505 13.7631C38.4405 13.8788 39.1436 14.153 39.9575 16.5281C40.7401 18.8146 46.0934 41.8568 46.1034 41.9111C46.6715 45.0687 45.237 45.3729 43.8762 45.9185C42.5312 46.4584 27.5122 50.0031 23.5139 50.9371C22.4671 51.1813 21.3209 51.2142 20.4374 50.91C19.7372 50.6686 18.9901 50.4701 18.189 47.8865C17.172 44.6046 12.5927 22.7249 12.5927 22.7249C12.5927 22.7249 12.1027 20.0314 14.7829 19.2159C17.4646 18.4004 25.1104 16.2924 25.1104 16.2924V16.2938Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M21.0262 14.0793C21.0262 14.0793 16.4072 14.8277 16.4754 16.263C16.5421 17.6969 16.5719 19.8977 18.8715 19.7149C21.1711 19.5321 33.7527 16.3973 34.5182 15.6432C35.2852 14.8877 34.6759 11.4415 33.4544 11.2358C32.2329 11.0302 28.7743 12.1899 28.7743 12.1899C28.7743 12.1899 27.2815 9.27351 24.3768 10.1718C21.4722 11.0702 21.0276 14.0808 21.0276 14.0808L21.0262 14.0793Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M17.6193 28.6922L32.2637 25.1162L31.9824 23.9518L17.338 27.5278L17.6193 28.6922Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M18.8083 33.6199L38.8398 28.7285L38.5586 27.5641L18.5271 32.4555L18.8083 33.6199Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M19.9978 38.5457L40.0293 33.6543L39.7481 32.4899L19.7166 37.3813L19.9978 38.5457Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M51.7853 23.3291L48.5156 20.5527L33.8651 37.9971L37.1347 40.7734L51.7853 23.3291Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M51.8276 18.8437L52.903 19.7568C53.5085 20.271 53.585 21.1827 53.0737 21.7916L51.7815 23.3301L48.5119 20.5538L49.804 19.0153C50.3153 18.4064 51.2221 18.3295 51.8276 18.8437Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path d='M33.868 37.9961L32.7402 42.6748L37.1377 40.7725L33.868 37.9961Z' fill={spotIllustration.primary.fill} />
    </Svg>
  )
}
